<template>
  <div class="tab_container">
    <!-- 业绩指标 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        业绩指标
        <el-button
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('performanceIndicator')"
          >保存</el-button
        >
      </div>
    </div>
    <performance-indicator ref="performanceIndicator" />
    <!-- 要事 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        要事
        <el-button
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('importantEvent')"
          >保存</el-button
        >
      </div>
    </div>
    <important-event ref="importantEvent" />
    <!-- 其他机会差距 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        其他机会差距
        <el-button
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('otherOpportunityGap')"
          >保存</el-button
        >
      </div>
    </div>
    <other-opportunity-gap ref="otherOpportunityGap" />
    <!-- 根因分析 (根据业绩、要事的差距描述逐一进行根因分析) -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        根因分析
        <el-button
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('rootCauseAnalysis')"
          >保存</el-button
        >
      </div>
    </div>
    <root-cause-analysis ref="rootCauseAnalysis" />
  </div>
</template>

<script>
import PerformanceIndicator from "./performanceIndicator.vue";
import ImportantEvent from "./importantEvent.vue";
import OtherOpportunityGap from "./otherOpportunityGap.vue";
import RootCauseAnalysis from "./rootCauseAnalysis.vue";
import { getLookGapApi } from "@/api/saleTaskCollection";

export default {
  components: {
    PerformanceIndicator,
    ImportantEvent,
    OtherOpportunityGap,
    RootCauseAnalysis
  },
  data() {
    return {};
  },
  methods: {
    async init(showDataObj) {
      await this.getLookGap(showDataObj.queryParams);
    },
    // 获取看差距
    async getLookGap(queryParams = {}) {
      try {
        let data = {};
        const res = await getLookGapApi({
          ...queryParams
        });
        if (res.status == 0) {
          data = res.data || {};
        } else {
          this.$DonMessage.error(res.message);
        }
        this.$refs.performanceIndicator.init(
          data.performanceIndicators,
          queryParams
        );
        this.$refs.importantEvent.init(
          data.somethingImportantList,
          queryParams
        );
        this.$refs.otherOpportunityGap.init(data.otherOpportunity, queryParams);
        this.$refs.rootCauseAnalysis.init(data.rootAnalysisList, queryParams);
        this.$emit(
          "updateTime",
          "lookGapTabTime",
          this.getClosestDate([
            data.performanceIndicators?.updateTime,
            data.somethingImportantList[0]?.updateTime,
            data.otherOpportunity?.updateTime,
            data.rootAnalysisList[0]?.updateTime
          ])
        );
      } catch (error) {}
    },
    // 获取最近的日期
    getClosestDate(dates) {
      if (dates.length === 0) return null; // 如果没有日期，返回null
      dates.sort((a, b) => a - b); // 按时间顺序排序
      return dates[0] || ""; // 取第一个元素，即最早的日期
    },
    // 保存
    handleSave(refField) {
      this.$refs[refField].handleSave(() => {
        this.$emit("updateTime");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tab_container {
  padding-bottom: 20px;
  .hearder_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title_icon {
      margin-right: 10px;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .second_title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .title_btn {
    margin-left: 20px;
  }
}
</style>
